/* UTV Wholesaler — Year/Make/Model finder, My Garage, fitment badges and UI helpers */
(function () {
  'use strict';
  var V = window.UTVW_VEHICLES || [];
  var BYK = {};
  V.forEach(function (v) { BYK[v.k] = v; });
  var MAKES = [];
  V.forEach(function (v) { if (MAKES.indexOf(v.mk) === -1) MAKES.push(v.mk); });
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'utvw_garage_v1';

  /* ---------- storage ---------- */
  function read() {
    try {
      var g = JSON.parse(localStorage.getItem(KEY));
      if (g && Array.isArray(g.list)) return g;
    } catch (e) {}
    return { list: [], active: null };
  }
  function write(g) {
    try { localStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('utvw:garage', { detail: g }));
  }
  function vid(v) { return v.k + '|' + v.y; }
  function valid(v) {
    var d = v && BYK[v.k];
    return !!(d && v.y >= d.y[0] && v.y <= d.y[1]);
  }
  function active() {
    var g = read();
    return valid(g.active) ? g.active : null;
  }
  function addVehicle(v) {
    if (!valid(v)) return;
    var g = read();
    g.list = g.list.filter(function (x) { return valid(x) && vid(x) !== vid(v); });
    g.list.unshift({ k: v.k, y: +v.y });
    g.list = g.list.slice(0, 6);
    g.active = { k: v.k, y: +v.y };
    write(g);
  }
  function removeVehicle(id) {
    var g = read();
    g.list = g.list.filter(function (x) { return vid(x) !== id; });
    if (g.active && vid(g.active) === id) g.active = g.list[0] || null;
    write(g);
  }
  function setActive(id) {
    var g = read();
    var hit = g.list.filter(function (x) { return vid(x) === id; })[0];
    if (hit) { g.active = hit; write(g); }
  }
  function shortModel(md) { return md.split(' / ')[0].replace(/\s*\(.*\)\s*$/, ''); }
  function label(v, short) {
    var d = v && BYK[v.k];
    if (!d) return '';
    return v.y + ' ' + d.mk + ' ' + (short ? shortModel(d.md) : d.md);
  }
  function vehicleUrl(v) { return ROOT + 'collections/' + v.k + '-accessories?yr=' + v.y; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  window.UTVW = { vehicles: V, byKey: BYK, read: read, active: active, add: addVehicle, remove: removeVehicle, label: label, url: vehicleUrl };

  /* ---------- fitment ---------- */
  function parseFit(str) {
    return (str || '').split('|').filter(Boolean).map(function (s) {
      var p = s.split(':');
      var r = (p[1] || '').split('-');
      var a = parseInt(r[0], 10) || 0;
      var b = parseInt(r[1], 10) || a || 9999;
      return { k: p[0], a: a, b: b };
    });
  }
  function fitStatus(el, v) {
    if (!v) return null;
    var fits = parseFit(el.getAttribute('data-fit'));
    var uni = el.getAttribute('data-uni') === '1';
    var same = fits.filter(function (f) { return f.k === v.k; });
    if (same.some(function (f) { return v.y >= f.a && v.y <= f.b; })) return 'fit';
    if (uni) return 'uni';
    if (same.length) return 'year';
    if (fits.length) return 'nofit';
    return 'unknown';
  }
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_U = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.5 2.6 2.5 14.4 0 17M12 3.5c-2.5 2.6-2.5 14.4 0 17"/></svg>';

  function chipFor(state, v) {
    var s = label(v, true);
    if (state === 'fit') return '<span class="utvw-chip utvw-chip--fit">' + ICON_OK + 'Fits your ' + esc(s) + '</span>';
    if (state === 'uni') return '<span class="utvw-chip utvw-chip--uni">' + ICON_U + 'Universal fit</span>';
    if (state === 'year' || state === 'nofit') return '<span class="utvw-chip utvw-chip--nofit">' + ICON_X + 'Not for your ' + esc(s) + '</span>';
    return '';
  }

  function paintCards(scope) {
    var v = active();
    var cards = (scope || document).querySelectorAll('[data-utvw-card]');
    var stats = { total: 0, fit: 0, uni: 0 };
    cards.forEach(function (card) {
      var slot = card.querySelector('.utvw-fit-slot');
      var st = fitStatus(card, v);
      card.setAttribute('data-fit-state', st || 'none');
      if (slot) slot.innerHTML = st ? chipFor(st, v) : '';
      stats.total++;
      if (st === 'fit') stats.fit++;
      if (st === 'uni') stats.uni++;
    });
    applyOnlyFit();
    document.querySelectorAll('[data-utvw-fitcount]').forEach(function (el) {
      el.textContent = v ? (stats.fit + stats.uni) + ' of ' + stats.total + ' on this page fit' : '';
    });
    return stats;
  }

  function applyOnlyFit() {
    var on = false;
    try { on = sessionStorage.getItem('utvw_onlyfit') === '1'; } catch (e) {}
    var v = active();
    document.querySelectorAll('[data-utvw-onlyfit]').forEach(function (i) { i.checked = on && !!v; i.disabled = !v; });
    document.querySelectorAll('[data-utvw-card]').forEach(function (card) {
      var st = card.getAttribute('data-fit-state');
      var hide = on && v && !(st === 'fit' || st === 'uni');
      var item = card.closest('.grid__item') || card;
      item.classList.toggle('utvw-hide', !!hide);
    });
  }

  function paintPanels() {
    var v = active();
    document.querySelectorAll('[data-utvw-fitpanel]').forEach(function (p) {
      var st = fitStatus(p, v);
      var box = p.querySelector('[data-utvw-fitstatus]');
      if (!box) return;
      var html, state;
      if (!v) {
        state = 'none';
        html = ICON_U.replace('<svg', '<svg style="opacity:.6"') + '<span>Select your vehicle to confirm this part fits.</span><button type="button" data-utvw-open-garage>Add vehicle</button>';
      } else if (st === 'fit') {
        state = 'fit';
        html = ICON_OK + '<span>Fits your <strong>' + esc(label(v)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else if (st === 'uni') {
        state = 'uni';
        html = ICON_U + '<span>Universal fit &mdash; check the specs for your <strong>' + esc(label(v, true)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else if (st === 'unknown') {
        state = 'none';
        html = ICON_U + '<span>Check the fitment notes below for your <strong>' + esc(label(v, true)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else {
        state = 'nofit';
        html = ICON_X + '<span>Does not list your <strong>' + esc(label(v)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      }
      box.setAttribute('data-state', state);
      box.innerHTML = html;
    });
  }

  function paintGarageButtons() {
    var v = active();
    document.querySelectorAll('[data-utvw-garage-btn]').forEach(function (b) {
      var t = b.querySelector('.utvw-garage-btn__veh');
      if (v) { b.setAttribute('data-has-vehicle', ''); if (t) t.textContent = label(v, true); b.setAttribute('aria-label', 'My Garage: ' + label(v)); }
      else { b.removeAttribute('data-has-vehicle'); if (t) t.textContent = t.getAttribute('data-empty') || 'Add vehicle'; b.setAttribute('aria-label', 'My Garage: add your vehicle'); }
    });
    document.querySelectorAll('[data-utvw-active-label]').forEach(function (el) { el.textContent = v ? label(v) : (el.getAttribute('data-empty') || 'No vehicle selected'); });
    document.querySelectorAll('[data-utvw-if-vehicle]').forEach(function (el) { el.hidden = !v; });
    document.querySelectorAll('[data-utvw-if-novehicle]').forEach(function (el) { el.hidden = !!v; });
    document.querySelectorAll('.utvw-fitbar').forEach(function (el) { el.classList.toggle('utvw-fitbar--empty', !v); });
    renderGarageList();
  }

  function renderGarageList() {
    var g = read();
    var a = active();
    document.querySelectorAll('[data-utvw-garage-list]').forEach(function (ul) {
      var items = g.list.filter(valid);
      ul.innerHTML = items.map(function (x) {
        var on = a && vid(a) === vid(x);
        return '<li' + (on ? ' data-active' : '') + '><a href="' + vehicleUrl(x) + '">' + esc(label(x)) + '</a>' +
          (on ? '<span class="utvw-chip utvw-chip--yellow">Active</span>' : '<button type="button" data-utvw-set="' + vid(x) + '">Select</button>') +
          '<button type="button" data-utvw-del="' + vid(x) + '" aria-label="Remove ' + esc(label(x)) + '">Remove</button></li>';
      }).join('');
      var h = ul.previousElementSibling;
      if (h && h.classList.contains('utvw-garage-list__h')) h.hidden = !items.length;
    });
  }

  function repaint() { paintGarageButtons(); paintCards(); paintPanels(); paintYearChips(); }

  /* ---------- finder element ---------- */
  function opt(v, t, sel) { var o = document.createElement('option'); o.value = v; o.textContent = t; if (sel) o.selected = true; return o; }

  class UtvwFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mk = this.querySelector('[data-role=make]');
      this.md = this.querySelector('[data-role=model]');
      this.yr = this.querySelector('[data-role=year]');
      this.go = this.querySelector('[data-role=go]');
      this.form = this.querySelector('form');
      if (!this.mk || !this.md || !this.yr) return;
      var self = this;
      MAKES.forEach(function (m) { self.mk.appendChild(opt(m, m)); });
      this.mk.addEventListener('change', function () { self.fillModels(); self.sync(); });
      this.md.addEventListener('change', function () { self.fillYears(); self.sync(); });
      this.yr.addEventListener('change', function () { self.sync(); });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
      var preset = this.getAttribute('data-preset');
      var v = active();
      if (preset && BYK[preset]) {
        this.select(preset, v && v.k === preset ? v.y : null);
      } else if (v) {
        this.select(v.k, v.y);
      }
      this.sync();
      document.addEventListener('utvw:garage', function () { var a = active(); if (a && !self.contains(document.activeElement)) { self.select(a.k, a.y); self.sync(); } });
    }
    select(k, y) {
      var d = BYK[k];
      if (!d) return;
      this.mk.value = d.mk;
      this.fillModels();
      this.md.value = k;
      this.fillYears();
      if (y) this.yr.value = String(y);
    }
    fillModels() {
      var mk = this.mk.value;
      this.md.innerHTML = '';
      this.md.appendChild(opt('', mk ? 'Select model' : 'Select make first'));
      var self = this;
      V.filter(function (v) { return v.mk === mk; }).forEach(function (v) { self.md.appendChild(opt(v.k, v.md + ' (' + v.y[0] + '–' + v.y[1] + ')')); });
      this.md.disabled = !mk;
      this.fillYears();
    }
    fillYears() {
      var d = BYK[this.md.value];
      this.yr.innerHTML = '';
      this.yr.appendChild(opt('', d ? 'Select year' : 'Select model first'));
      if (d) for (var y = d.y[1]; y >= d.y[0]; y--) this.yr.appendChild(opt(y, y));
      this.yr.disabled = !d;
    }
    sync() {
      [this.mk, this.md, this.yr].forEach(function (s) { s.closest('.utvw-select').classList.toggle('is-done', !!s.value); });
      if (this.go) this.go.disabled = !(this.md.value && this.yr.value);
    }
    submit() {
      var v = { k: this.md.value, y: parseInt(this.yr.value, 10) };
      if (!valid(v)) return;
      addVehicle(v);
      var mode = this.getAttribute('data-mode') || 'navigate';
      var dlg = this.closest('dialog');
      if (mode === 'stay') { if (dlg) dlg.close(); repaint(); return; }
      window.location.href = vehicleUrl(v);
    }
  }
  if (!customElements.get('utvw-finder')) customElements.define('utvw-finder', UtvwFinder);

  /* ---------- year chips on vehicle hubs ---------- */
  function paintYearChips() {
    var v = active();
    document.querySelectorAll('[data-utvw-years]').forEach(function (wrap) {
      var k = wrap.getAttribute('data-utvw-years');
      var d = BYK[k];
      if (!d) return;
      if (!wrap.childElementCount) {
        var h = '';
        for (var y = d.y[1]; y >= d.y[0]; y--) h += '<button type="button" data-y="' + y + '" aria-pressed="false">' + y + '</button>';
        wrap.innerHTML = h;
      }
      wrap.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', v && v.k === k && String(v.y) === b.getAttribute('data-y') ? 'true' : 'false'); });
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-utvw-open-garage]');
    if (t) {
      e.preventDefault();
      var d = document.getElementById('utvw-garage');
      if (d && d.showModal) { d.showModal(); var s = d.querySelector('select:not([disabled])'); if (s) setTimeout(function () { s.focus(); }, 60); }
      return;
    }
    var c = e.target.closest('[data-utvw-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    var del = e.target.closest('[data-utvw-del]');
    if (del) { removeVehicle(del.getAttribute('data-utvw-del')); return; }
    var set = e.target.closest('[data-utvw-set]');
    if (set) { setActive(set.getAttribute('data-utvw-set')); return; }
    var clr = e.target.closest('[data-utvw-clear]');
    if (clr) { var g = read(); g.active = null; write(g); return; }
    var yc = e.target.closest('[data-utvw-years] button');
    if (yc) { addVehicle({ k: yc.closest('[data-utvw-years]').getAttribute('data-utvw-years'), y: parseInt(yc.getAttribute('data-y'), 10) }); return; }
    var more = e.target.closest('[data-utvw-more]');
    if (more) { var b = document.getElementById(more.getAttribute('aria-controls')); if (b) { var open = b.classList.toggle('is-clamped') === false; more.setAttribute('aria-expanded', open); more.textContent = open ? 'Show less' : 'Read more'; } }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-utvw-onlyfit]')) {
      try { sessionStorage.setItem('utvw_onlyfit', e.target.checked ? '1' : '0'); } catch (x) {}
      applyOnlyFit();
    }
  });
  document.addEventListener('click', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DIALOG' && d.classList.contains('utvw-modal')) d.close();
  });
  document.addEventListener('utvw:garage', repaint);

  /* re-paint after Dawn re-renders the product grid (filters, sorting, pagination) */
  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.collection');
    if (!grid || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { paintCards(); }, 40); }).observe(grid, { childList: true, subtree: true });
  }

  /* vehicle collection: ?yr=YYYY selects the vehicle */
  function adoptUrlVehicle() {
    var host = document.querySelector('[data-utvw-vehicle-key]');
    if (!host) return;
    var k = host.getAttribute('data-utvw-vehicle-key');
    var m = /[?&]yr=(\d{4})/.exec(location.search);
    if (m && BYK[k]) {
      var v = { k: k, y: parseInt(m[1], 10) };
      var a = active();
      if (valid(v) && (!a || vid(a) !== vid(v))) addVehicle(v);
    }
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = document.querySelectorAll('.utvw-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- sticky add-to-cart on mobile ---------- */
  function stickyAtc() {
    var bar = document.querySelector('.utvw-sticky-atc');
    var btn = document.querySelector('.product-form__submit');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);
    bar.querySelector('button').addEventListener('click', function () { btn.click(); });
  }

  function init() {
    adoptUrlVehicle();
    repaint();
    watchGrid();
    reveal();
    stickyAtc();
    document.querySelectorAll('[data-utvw-clamp]').forEach(function (b) { if (b.scrollHeight > 420) { b.classList.add('is-clamped'); var m = b.parentNode.querySelector('[data-utvw-more]'); if (m) m.hidden = false; } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
